import { styled } from "styled-components";

import { theme } from "theme";

import { Typography } from "styled/Typography";

export const SummaryItemLabel = styled(Typography.Description)`
  color: ${theme.color.text.tertiary};
`;
